import React, { Component } from 'react';

import GlobalGrid from '../../components/GlobalGrid';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { BsSearch } from 'react-icons/bs';
import { ThemeContext } from '../../context/theme.context';
import { loadingShow } from '../../App';
import Message from '../../utils/Message/Message';
import { SyncFullMexPMOperations } from '../../services/MexServices/PreventativeMaintenances/MexPreventativeMaintenanceServices';
import { SyncFullMexPMTaskOperations } from '../../services/MexServices/PreventativeMaintenanceTaskService/PreventativeMaintenanceTaskService';
interface IState {
  current_query: string;
  searchText: string;
  loadSignal: boolean;
}
interface IProps { }

let ERP_TYPE = process.env.REACT_APP_ERP_TYPE
const erpTypeName = 'MEX'


export default class MaintanceStrategies extends Component<IProps, IState> {
  public validationRule: Object = { required: true };
  private current_query: string = '';
  private theQuerySearch = '';


  context!: React.ContextType<typeof ThemeContext>;
  constructor(prop: IProps) {
    super(prop);
    this.state = {
      current_query: '',
      searchText: '',
      loadSignal: false,
    };
  }


  template = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          alignSelf: 'flex-end',
          height: 25,
        }}
      >
        <TextBoxComponent
          type={'text'}
          id='work_orders'
          autocomplete='off'
          input={this.inputEnterPress.bind(this)}
          showClearButton
          placeholder='Search'
          onChange={(args: any) => {
            this.setState({ searchText: args.target.value });
          }}
        />
        <div
          style={{
            borderRightColor: 'transparent',
            borderTopColor: 'transparent',
            borderBottomColor: 'transparent',
          }}
        >
          <BsSearch color={this.context.isDarkMode ? '#eaeaea' : '#292525'} className={'searchIcon'} onClick={this.search.bind(this)} />
        </div>
      </div>
    );
  };
  inputEnterPress(e: any) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      this.search();
    }
  }
  search() {
    if (this.state.searchText !== '' || this.current_query !== '') {
      this.buildQuery(true);
    }
  }
  buildQuery(clearRequest: boolean) {
    this.current_query = this.state.current_query.trimEnd();
    this.current_query = this.current_query.replace(this.theQuerySearch, '');

    this.theQuerySearch = '';
    if (this.state.searchText !== '') {
      this.theQuerySearch = '$' + this.state.searchText;
      this.current_query = this.current_query + this.theQuerySearch;
    }
    this.setState({
      current_query: this.current_query + ' ',
      loadSignal: true,
    });
  }
  addToQuery = (
    field: string,
    c: string,
    type: string,
    v: string,
    current_query: string
  ) => {
    current_query = JSON.stringify({
      f: field,
      c: c,
      t: type,
      v: v,
    });
    current_query += '?';
    this.current_query += current_query;
    return current_query;
  };
  public toolbarClickExtends = async (args: any) => {

    if (args.item.id === 'sync_full') {
      loadingShow(true, "Waiting for preventative maintenance sync operations...")
      SyncFullMexPMOperations().then((result) => {
        if (result.status == 200) {
          loadingShow(false);
          Message.success('Synced successfully...');
        }

      })
        .catch((err) => {
          loadingShow(false);
          Message.error('Sync failed!!!');
        }).finally(() => {
          loadingShow(true, "Waiting for preventative maintenance task sync operations...")
          SyncFullMexPMTaskOperations().then((result) => {
            if (result.status == 200) {
              loadingShow(false);
              Message.success('Synced successfully...');
            }

          })
            .catch((err) => {
              loadingShow(false);
              Message.error('Sync failed!!!');
            });
        }


        );



    }
  }

  public toolbarOptions: any = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    'ColumnChooser',
    'ExcelExport',
    {
      text: 'Sync Full',
      tooltipText: 'Sync Full',
      //prefixIcon: '',
      id: 'sync_full',
      visible: ERP_TYPE === erpTypeName ? true : false,
    },
    'Search',
  ];

  taskTemplate(index: number, e: any) {
    var theValue = e[`included_task${index}`];
    return (
      <div>
        {theValue !== 0 ? (
          <div style={{ color: '#22d3ee' }}>
            <span>{theValue}</span>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
  theColumns = [
    {
      field: 'plt_pm_task_no',
      headerText: 'PM Task Number',
      textAlign: 'Left',
      width: 60,
      isPrimary: true,
    },
    {
      field: 'plt_pm_task_text',
      headerText: 'Description',
      textAlign: 'Left',
      allowEditing: true,
    },
    {
      field: 'plt_pm_task_type',
      headerText: 'Type',
      textAlign: 'Left',
    },
    {
      field: 'pm_section_code',
      headerText: 'Section Code',
      textAlign: 'Left',
      allowEditing: true,
      visible: ERP_TYPE === erpTypeName ? false : true,

    },
    {
      field: 'pm_frequency_uom',
      headerText: 'Frequency Uom',
      textAlign: 'Left',
    },
    {
      field: 'pm_instruction_mex',
      headerText: 'PM Instruction',
      textAlign: 'Left',
      visible: ERP_TYPE === erpTypeName ? true : false,
      width: 250,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'pm_safety_note_mex',
      headerText: 'PM Safety Note',
      textAlign: 'Left',
      width: 250,
      visible: ERP_TYPE === erpTypeName ? true : false,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'plt_pm_last_done',
      headerText: 'PM last done',
      textAlign: 'Left',
      width: 50,
      type: 'datetime',
      format: 'dd/MM/yyyy HH:mm',
      visible: ERP_TYPE === erpTypeName ? false : true,

    },
    {
      field: 'code',
      headerText: 'Code',
      textAlign: 'Left',
      visible: ERP_TYPE === erpTypeName ? false : true,

    },

    {
      field: 'pm_next_due_date',
      headerText: 'Next Due',
      textAlign: 'Left',
      type: 'datetime',
      format: 'dd/MM/yyyy HH:mm',
    },

    {
      field: 'due_reset_type',
      headerText: 'Due Reset Type',
      textAlign: 'Left',
      visible: ERP_TYPE === erpTypeName ? false : true,

    },
    {
      field: 'plt_pm_downtime',
      headerText: 'Downtime',
      textAlign: 'Left',
      format: 'dd/MM/yyyy',
      type: 'date',
      visible: ERP_TYPE === erpTypeName ? false : true,

    },
    {
      field: 'included_task1',
      headerText: 'Task 1',
      textAlign: 'Left',

      template: this.taskTemplate.bind(this, 1),
      visible: ERP_TYPE === erpTypeName ? false : true,

    },
    {
      field: 'included_task2',
      headerText: 'Task 2',
      textAlign: 'Left',
      template: this.taskTemplate.bind(this, 2),
      visible: ERP_TYPE === erpTypeName ? false : true,

    },
    {
      field: 'included_task3',
      headerText: 'Task 3',
      textAlign: 'Left',
      template: this.taskTemplate.bind(this, 3),
      visible: ERP_TYPE === erpTypeName ? false : true,

    },
    {
      field: 'included_task4',
      headerText: 'Task 4',
      textAlign: 'Left',
      template: this.taskTemplate.bind(this, 4),
      visible: ERP_TYPE === erpTypeName ? false : true,

    },

    {
      field: 'pm_labour_type_1',
      headerText: 'Trade1',
      textAlign: 'Left',
      allowEditing: true,
      visible: ERP_TYPE === erpTypeName ? false : true,

    },
    {
      field: 'pm_labour_qty_1',
      headerText: 'Qty1',
      textAlign: 'Left',
      allowEditing: true,
      visible: ERP_TYPE === erpTypeName ? false : true,

    },
    {
      field: 'est_hours_1',
      headerText: 'Est1',
      textAlign: 'Left',
      allowEditing: true,
    },
    {
      field: 'pm_labour_type_2',
      headerText: 'Trade2',
      textAlign: 'Left',
      allowEditing: true,
      visible: ERP_TYPE === erpTypeName ? false : true,

    },
    {
      field: 'pm_labour_qty_2',
      headerText: 'Qty2',
      textAlign: 'Left',
      allowEditing: true,
      visible: ERP_TYPE === erpTypeName ? false : true,

    },
    {
      field: 'est_hours_2',
      headerText: 'Est2',
      textAlign: 'Left',
      allowEditing: true,
      visible: ERP_TYPE === erpTypeName ? false : true,

    },
    {
      field: 'pm_labour_type_3',
      headerText: 'Trade3',
      textAlign: 'Left',
      allowEditing: true,
      visible: ERP_TYPE === erpTypeName ? false : true,

    },
    {
      field: 'pm_labour_qty_3',
      headerText: 'Qty3',
      textAlign: 'Left',
      allowEditing: true,
      visible: ERP_TYPE === erpTypeName ? false : true,

    },
    {
      field: 'est_hours_3',
      headerText: 'Est3',
      textAlign: 'Left',
      allowEditing: true,
      visible: ERP_TYPE === erpTypeName ? false : true,

    },
    {
      field: 'pm_labour_type_4',
      headerText: 'Trade4',
      textAlign: 'Left',
      allowEditing: true,
      visible: ERP_TYPE === erpTypeName ? false : true,

    },
    {
      field: 'pm_labour_qty_4',
      headerText: 'Qty4',
      textAlign: 'Left',
      allowEditing: true,
      visible: ERP_TYPE === erpTypeName ? false : true,

    },

    {
      field: 'est_hours_4',
      headerText: 'Est4',
      textAlign: 'Left',
      allowEditing: true,
      visible: ERP_TYPE === erpTypeName ? false : true,

    },
    {
      field: 'section_code',
      headerText: 'Section',
      textAlign: 'Left',
      allowEditing: true,
      visible: ERP_TYPE === erpTypeName ? false : true,

    },
    {
      field: 'plt_pm_frequency',
      headerText: 'Frequency',
      textAlign: 'Left',
      allowEditing: true,
    },
    {
      field: 'plt_pm_priority',
      headerText: 'Priority',
      textAlign: 'Left',
      allowEditing: true,
    },
    {
      field: 'code',
      headerText: 'Resp',
      textAlign: 'Left',
      allowEditing: true,
      visible: ERP_TYPE === erpTypeName ? false : true,

    },
    {
      field: 'S_Material_Cost',
      headerText: 'S_Material_Cost',
      allowEditing: false,
      format: 'C2',
      visible: ERP_TYPE === erpTypeName ? false : true,
    },
    {
      field: 'S_Labour_Cost',
      textAlign: 'Left',
      headerText: 'S_Labour_Cost',
      allowEditing: false,
      format: 'C2',
      visible: ERP_TYPE === erpTypeName ? false : true,
    },
    {
      field: 'S_Other_Cost',
      textAlign: 'Left',
      headerText: 'S_Other_Cost',
      allowEditing: false,
      format: 'C2',
      visible: ERP_TYPE === erpTypeName ? false : true,
    },
    {
      field: 'pm_cost_material',
      headerText: 'S_Material_Cost',
      allowEditing: false,
      format: 'C2',
      visible: ERP_TYPE === erpTypeName ? true : false,
    },
    {
      field: 'pm_cost_labour',
      textAlign: 'Left',
      headerText: 'S_Labour_Cost',
      allowEditing: false,
      format: 'C2',
      visible: ERP_TYPE === erpTypeName ? true : false,
    },
    {
      field: 'pm_cost_other',
      textAlign: 'Left',
      headerText: 'S_Other_Cost',
      allowEditing: false,
      format: 'C2',
      visible: ERP_TYPE === erpTypeName ? true : false,
    },
    {
      field: 'T_Material_Cost',
      headerText: 'T_Material_Cost',
      editType: 'numericedit',
      allowEditing: true,
      format: 'C2',
      visible: ERP_TYPE === erpTypeName ? false : true,

    },
    {
      field: 'T_Labour_Cost',
      textAlign: 'Left',
      headerText: 'T_Labour_Cost',
      editType: 'numericedit',
      allowEditing: true,
      format: 'C2',
      visible: ERP_TYPE === erpTypeName ? false : true,

    },
    {
      field: 'T_Other_Cost',
      textAlign: 'Left',
      headerText: 'T_Other_Cost',
      editType: 'numericedit',
      allowEditing: true,
      format: 'C2',
      visible: ERP_TYPE === erpTypeName ? false : true,

    },
    {
      field: 'total',
      textAlign: 'Left',
      headerText: 'Total',
      format: 'C2',
      allowEditing: false,
      visible: ERP_TYPE === erpTypeName ? false : true,
    },
    {
      field: 'pm_cost_total',
      textAlign: 'Left',
      headerText: 'Total',
      format: 'C2',
      allowEditing: false,
      visible: ERP_TYPE === erpTypeName ? true : false,
    },
  ];
  render() {
    return (
      <div>
        <GlobalGrid
          columns={this.theColumns}
          height={'calc(-290px + 100vh)'}
          query={this.current_query}
          toolbarOptions={this.toolbarOptions}
          get_query={'maintance-strg'}
          id={'asset-mng-grid'}
          isFitInCOntent={false}
          edit_query={'asset_cost_master_edit'}
          signalOfLoad={true}
          additinalToolbarClick={this.toolbarClickExtends.bind(this)}
        />
      </div>
    );
  }
}
